export default __webpack_public_path__ + "static/airplane-de5c7a7b1c3c71de4f157582d0fc756c.png";